/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "two-way-exchange",

    getDefaultProps: function getDefaultProps() {
        return {
            "twoWayExchange": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "77.9",
            "height": "70.6"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 77.9 70.6", className: "two-way-exchange", width: this.props.width, height: this.props.height, style: this.props.twoWayExchange },
            _react2["default"].createElement("path", { fill: "#999", d: "M57.7 57.3v13.3l20.2-20.1-20.2-20.2v13.3H35v13.7zM21.6 29.5v13.3L1.4 22.6 21.6 2.4v13.3h22.8v13.8z" })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/two-way-exchange.js